import { createAction, props } from '@ngrx/store';
import { WorkFlowConfig, WorkFlowEntity } from 'src/app/models/WorkFlow';

export const setWorkFlowConfig = createAction('[WorkFlow] Set WorkFlowConfig', props<{ workFlowConfig: WorkFlowConfig[] | undefined }>());
export const setWorkFlowInstance = createAction(
  '[WorkFlow] Set WorkFlowInstance',
  props<{ workFlowInstance: WorkFlowEntity[] | undefined }>()
);
export const resetWorkFlow = createAction('[WorkFlow] Reset WorkFlow');
